/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Status_ThinkingInputs */



/**
* | output |
* | --- |
* | "Thinking…" |
*
* @param {Practice_Session_Status_ThinkingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_status_thinking = /** @type {((inputs?: Practice_Session_Status_ThinkingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Status_ThinkingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Even denken…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réflexion…")
	return /** @type {LocalizedString} */ ("Thinking…")
});